import { Button, message } from "antd";
import React, { useState } from "react";

export default function CopyButton(props) {

    const { label = "Copy", copy_text = "TODO", error_text = "Can't copy", success_text = "Copied!", block = true, buttonProps = {} } = props;

    const [copied, setCopied] = useState(false);
    const copyToClipboard = (e) => {
        if (!navigator.clipboard) {
            message.error(error_text);
            return;
        }
        navigator.clipboard.writeText(copy_text);
        setCopied(true);
        setTimeout(() => {
            setCopied(false)
        }, 1000);
    }

    return (
        <Button {...buttonProps} block={block} type={(copied ? "primary" : "default")} onClick={() => copyToClipboard(copy_text)} >{(copied) ? success_text : label}</Button>
    )


}